import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';

const SortableTh = ({
  sortKey,
  label,
  sort,
  onSort,
  getSortIcon,
  className = '',
  sortable = true,
  colSpan,
  rowSpan,
  style,
  title,
}) => {
  if (!sortable || !sortKey || !onSort) {
    return (
      <th className={className} colSpan={colSpan} rowSpan={rowSpan} style={style} title={title}>
        {label}
      </th>
    );
  }

  const icon = getSortIcon ? getSortIcon(sortKey) : 'mdi:unfold-more-horizontal';
  const isActive = sort?.key === sortKey;

  return (
    <th
      className={`sortable-th${isActive ? ' is-sorted' : ''}${className ? ` ${className}` : ''}`}
      colSpan={colSpan}
      rowSpan={rowSpan}
      style={style}
      title={title || label}
      onClick={() => onSort(sortKey)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSort(sortKey);
        }
      }}
      role="columnheader"
      aria-sort={isActive ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      tabIndex={0}
    >
      <span className="sortable-th__content">
        <span className="sortable-th__label">{label}</span>
        <Icon icon={icon} className="sortable-th__icon" aria-hidden />
      </span>
    </th>
  );
};

export default SortableTh;
